<template>
    <div class="goods_cate">
      <category-List ref="cateGory"></category-List>
      <div class="wrapper sort-count">
        <div class="sort acea-row">
          <div class="name">{{ $tt('排序：') }}</div>
          <div class="acea-row">
            <div class="item" :class="iSdefaults === 0?'font-color':''" @click="defaults">{{ $tt('默认') }}</div>
            <div class="item" :class="iSdefaults === 1?'font-color':''" @click="salesSort('sales')">
              {{ $tt('销量') }}
            </div>
            <div class="item" :class="iSdefaults === 3?'font-color':''" @click="salesRate('rate')">
              {{ $tt('评分') }}
            </div>
            <div class="item" :class="iSdefaults === 2?'font-color':''" @click="priceSort('price_desc')" v-if="priceOrder === 'price_asc'">
              {{ $tt('价格') }}
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-jiageshaixuanshang"></use>
              </svg>
            </div>
            <div class="item" :class="iSdefaults === 2?'font-color':''" @click="priceSort('price_asc')" v-else-if="priceOrder === ''">
              {{ $tt('价格') }}
              <span class="iconfont icon-jiageshaixuan"></span>
            </div>
            <div class="item" :class="iSdefaults === 2?'font-color':''" @click="priceSort('price_asc')" v-else>
              {{ $tt('价格') }}
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-jiageshaixuanxia"></use>
              </svg>
            </div>
            <div class="item price-range">
                <div class="price-count">
                    <el-input class="input" v-model.number="price_on" @input="change($event)"></el-input> -
                    <el-input class="input" v-model.number="price_off" @input="change($event)"></el-input>
                </div>
                <div class="action-box">
                    <span class="action-btn clear" @click="clearPrice">{{ $tt('清空') }}</span>
                    <span class="action-btn submit" @click="getProductslist('')">{{ $tt('确定') }}</span>
                </div>
            </div>
          </div>
        </div> 
      </div>
      <div class="coupon-count wrapper_1200">
          <p>{{ $tt('以下商品适用于') }}<span>{{ $tt('满') }}{{couponData.use_min_price}}{{ $tt('减') }}{{couponData.coupon_price}}</span></p>
       </div>
      <div class="wrapper_1200">
        <div v-if="productslist.length">
          <div class="goods acea-row row-middle">
            <div class="item" v-for="(item, index) in productslist" :key="index" @click="goDetail(item)">
              <div class="pictrue"><img :src="item.image"></div>
              <div class="money acea-row row-between-wrapper">
                <div><span class="font-color">NZ${{item.price}}</span></div>
                <div class="label font-color" v-if="item.issetCoupon">{{ $tt('券') }}</div>
              </div>
              <div class="name line2"> <span v-if="item.merchant.is_trader && item.product_type == 0" class="trader">{{ $tt('自营') }}</span><span v-else-if="item.product_type == 1" class="trader">{{ $tt('秒杀') }}</span> {{item.store_name}}</div>
              <div class="bottom acea-row row-between-wrapper">
                <div>{{item.sales}}{{ $tt('人付款') }}</div>
              </div>
              <div class="item_tags acea-row">
								<span v-if="item.merchant.type_name && item.product_type == 0" class="font-bg-red">{{item.merchant.type_name}}</span>
								<span v-else-if="item.merchant.is_trader && item.product_type == 0" class="font-bg-red">{{ $tt('自营') }}</span>
								<span class="tags_item ticket" >{{ $tt('满减') }}</span>
							</div>
            </div>
          </div>
          <el-pagination v-if="total > 0" background layout="prev, pager, next" :total="total" :pageSize="limit" @current-change="bindPageCur"></el-pagination>
        </div>
      </div>
      <div v-if="!productslist.length">
        <div class="noGoods">
          <div class="pictrue">
            <img src="../assets/images/noGoods.png">
          </div>
          <div class="name">{{ $tt('亲，该分类暂无商品哟~') }}</div>
        </div>
      </div>
    </div>
</template>
<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import categoryList from "@/components/categoryList";
export default {
      name: "goods_cate",
      auth: false,
      components: {
        categoryList
      },
      data(){
        return {
          isCollect: false,
          storeList: [],
          brandList:[],
          brandCurrent:[],
          couponData: {},
          current:0,
          moreCurrent:0,
          seen:false,
          titleName:'',
          erCurrent:0,
          iSdefaults:0,
          productslist:[],
          pullRefreshss: true, // 代表可以进行下拉加载，false代表不能
          page: 1, //代表页面的初始页数
          limit:15,
          scollY: null,// 离底部距离有多少
          total: 0, //总页数
          title:'下拉加载更多',
          cid:0,//一级分类
          sid:'',//二级分类
          order: '',
          priceOrder: '',
          price_on: '',
          price_off: '',
          news:0,
          is_multiple: false,
          checkedBrands: [],
          is_showMore: true,
          searchVal: '',
          search: '',
          storeLength: false,
        }
      },
      async asyncData({app,query}){
        return {
          keyword: query.title ? query.title : '',
          coupon_id: query.id ? query.id:'',
          titleName: query.name ? decodeURI(query.name).split(',') : '',
        }
      },
      watch:{
        $route: {
            handler: function(newVal, oldVal){
                this.keyword = newVal.query.title ? newVal.query.title : '';
                this.searchVal = newVal.query.title ? newVal.query.title : '';
                this.coupon_id = newVal.query.id ? newVal.query.id : '';
                this.titleName = newVal.query.name ? decodeURI(newVal.query.name).split(',') : '';
                this.page = 1;
                this.getProductslist(1);
            },
            // 深度观察监听
            deep: true
        },
        is_multiple(n){
          this.checkedBrands = [];
          if(!n) {
            this.current = 0;
          }
        },
      },
      fetch({ store}) {
        store.commit("isBanner", false);
        store.commit('isHeader', true);
        store.commit('isFooter', true);
      },
      head() {
        return {
          title: "优惠券可用商品-"+this.$store.state.titleCon
        }
      },
      beforeMount(){
        this.searchVal = this.$route.query.title;
        this.coupon_id = this.$route.query.id || '';
        this.getProductslist('');
      },
      mounted(){},
      beforeDestroy() {},
      methods:{
        bindSubmit(){
            this.getProductslist(1);
        },
        handleClose(){
            this.checkedBrands = [];
            this.searchVal = this.search = "";
            this.getProductslist(1);
        },
        toggleMultiple(){
          this.is_multiple = !this.is_multiple
          if(!this.is_multiple) this.search = ''
        },
        clearPrice(){
            this.price_on = this.price_off = "";
        },
        change(e){
            this.$forceUpdate()
        },
        /**获取品牌*/
        getBrandList(){
          let _this = this;
          _this.$axios.get('/api/store/product/brand/lst',{
            params:{
              limit: 999,
              keyword: _this.keyword,
              pid: _this.sid
            }
          }).then(function (res) {
            _this.brandList = res.data.list
            _this.brandList.unshift({
              'brand_id': '',
              'brand_name': '全部'
            })
          }).catch(function (err) {
            _this.$message.error(err);
          })
        },
        goCate(item, index) {
          if((index + 1) === this.titleName.length){
            return ;
          }
          const name = this.titleName.reduce((initial, val, idx) => {
            if (idx > index) {
              return initial;
            } else {
              initial.push(val);
              return initial;
            }
          }, []);
          this.$router.push({
            path: `/goods_cate`,
            query: {
              sid: item.split('_')[1],
              name: encodeURI(name.join(',')),
              // name: encodeURI(name.substring(0,name.length-1))
            }
          })
        },
        /**取出多选选中的项 */
        getSelectedItem(){
            if(this.checkedBrands.length > 0){
                this.search = '';
                for(var i=0;i<this.checkedBrands.length;i++){
                    for(var j=0;j<this.brandList.length;j++){
                        if(this.checkedBrands[i] == this.brandList[j]['brand_id']){
                            this.search += this.brandList[j]['brand_name']+',';
                            this.search =  this.subStr(this.search,10)
                        }
                    }
                }
                this.search = this.search.substr(0, this.search.length - 1);
            }
        },
        /**超出省略号代替 */
        subStr(str,max){
            if(str.length > max){
                str = str.substring(0,max) + '...';
            }
             return str;
        },
        goDetail: function (item) {
          if(item.product_type == 1){
            this.$router.push({ path: '/goods_seckill_detail/'+item.product_id,query: { time: item.stop_time,status: item.seckill_status } });
          }else if(item.product_type == 2){
            this.$router.push({ path: '/goods_presell_detail/'+item.product_presell_id });
          }else{
            this.$router.push({ path: '/goods_detail/'+item.product_id });
          }
        }, 
        getProductslist(num){
          let _this = this;
          _this.page = num ? num : _this.page;
          let  currentPage = {coupon_id:this.coupon_id,page: _this.page,limit:_this.limit,keyword: _this.keyword,brand_id: _this.checkedBrands.toString(),
                         price_on: _this.price_on,price_off: _this.price_off,order: _this.order,cate_pid: _this.sid};
          _this.$axios.get('/api/product/spu/coupon_product', {
            params: currentPage
          }).then(function (res) {
            _this.couponData = res.data.coupon;
            _this.total = res.data.count;
            _this.productslist = res.data.list;
          }).catch(function (err) {
            _this.$message.error(err);
          })
        },
        // 分页点击
        bindPageCur(data){
            this.page = data
            this.getProductslist('');
        },
        category(index){
          this.checkedBrands = [];
          this.current = index;
          this.moreCurrent = index;
          this.brandCurrent = this.brandList[index].children;
          this.productslist = [];
          this.page = 1;
          this.erCurrent = 0;
          this.order = '';
          this.checkedBrands[0] = this.brandList[index]['brand_id'];
          this.getProductslist('');
        },
        defaults(){
          this.iSdefaults = 0;
          this.productslist = [];
          this.page = 1;
          this.order = '';
          this.priceOrder = '';
          this.getProductslist('');
        },
        priceSort(sort){
          this.iSdefaults = 2;
          this.productslist = [];
          this.page = 1;
          this.order = sort;
          this.priceOrder = sort;
          this.getProductslist('');
        },
        salesSort(sort){
          this.iSdefaults = 1;
          this.productslist = [];
          this.page = 1;
          this.order = sort;
          this.priceOrder = '';
          this.getProductslist('');
        },
        salesRate(rate){
          this.iSdefaults = 3;
          this.productslist = [];
          this.page = 1;
          this.order = rate;
          this.priceOrder = '';
          this.getProductslist('');
        }
      }
    }
</script>

<style scoped lang="scss">
  .trader{
    color: #fff;
    background-color: #e93323;
    display: inline-block;
    width: 32px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 2px;
    margin-right: 5px;
    font-size: 12px;
  }
  .cate_name{
    cursor: pointer;
    &.on{
      color: #E93323
    }
  }
  .coupon-count{
    height: 50px;
    background: #FFF1EF;;
    display: flex;
    align-items: center;
    margin-top: 20px;
    padding: 0 15px;
    p{
      display: flex;
      span{
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 150px;
        padding: 1px 8px;
        margin-left: 12px;
        background-size: 100% 100%;
        font-size: 12px;
        background-image: url("~assets/images/coupon-price.png");
        color: #E93323;
      }
    }
   
  }
  .goods_cate{
    margin-top: 2px;
    .noGoods{
      text-align: center;
      .pictrue{
        width: 274px;
        height: 174px;
        margin: 130px auto 0 auto;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .name{
        font-size: 14px;
        color: #969696;
        margin-top: 20px;
        margin-bottom: 290px;
      }
    }
    .nav{
      width: 100%;
      height: 50px;
      &.showMore{
          height: auto;
          .list{
              height: auto;
          }
      }
      cursor: pointer;
      .navCon{
        padding: 0 17px;
        position: relative;
        &:after{
            content: '';
            display: inline-block;
            position: absolute;
            width: 1140px;
            border-bottom: 1px dotted #EFEFEF;
            bottom: 0;
            left: 60px;
        }
        &.wrapper_1200{
          overflow: unset!important;
          background-color: #fff;
        }
        height: 100%;
        .name{
            color: #969696;
            margin-right: 20px;
            line-height: 50px;
        }
        .moreCon{
          position: relative;
          height: 50px;
          .moreCategory{
            padding: 44px 44px 16px 44px;
            position: absolute;
            top:50px;
            right: -17px;
            width: 1200px;
            background-color: #fff;
            box-shadow: 0 3px 16px rgba(0, 0, 0, 0.06);
            .item{
              margin: 0 40px 28px 0;
              &:hover{
                color: #E93323;
              }
            }
          }
          .multiBtn{
              display: inline-block;
              width: 38px;
              height: 18px;
              line-height: 18px;
              border: 1px solid #C8C8C8;
              text-align: center;
              border-radius: 2px;
              margin-right: 18px;
          }
        }
        .list{
          height: 100%;
          width: 1020px;
          overflow: hidden;
          margin-right: 10px;
          .item{
            line-height: 50px;
            overflow: hidden;
            margin-right: 40px;

            &:hover{
              color: #E93323;
            }
          }
        }
        .more{
          position: relative;
          line-height: 50px;
          text-align: center;
          .iconfont{
            margin-left: 6px;
            font-size: 12px;
            color: #666666;
            display: inline-block;
            transition: all .1s ease;
            &.shouqi{
                 -moz-transform: rotateX(180deg);
                 -o-transform: rotateX(180deg);
                 -ms-transform: rotateX(180deg);
                 transform: rotateX(180deg);
            }
          }
        }
      }
    }
    .el-checkbox{
        height: 50px;
        line-height: 50px;
        color: #282828;
    }
    .title{
      color: #999999;
      height: 46px;
      line-height: 46px;
      .home{
        color: #282828;
      }
    }
    .sort-count{
        width: 1200px;
        margin: 0 auto;
    }
    .wrapper{
      background-color: #fff;
      padding: 25px 17px 0;
      cursor: pointer;
      .list{
        width: 1100px;
        border-bottom: 1px dotted #EFEFEF;
        padding-bottom: 10px;
        .item{
          margin-right: 30px;
          margin-bottom: 10px;
          &:hover{
            color: #E93323;
          }
        }
      }

      .sort{
        .item{
          margin-right: 30px;
          &:hover{
            color: #E93323;
          }
          .icon{
            font-size: 15px;
            margin-left: 5px;
          }
          .iconfont{
            font-size: 15px;
            color: #E2E2E2;
            margin-left: 5px;
          }
        }
        .name{
            color: #969696;
            margin-right: 20px;
        }
      }
    }
    .goods{
      width: 1220px;
      .item{
        background-color: #fff;
        padding: 16px;
        width: 224px;
        margin: 20px 20px 0 0;
        cursor: pointer;
        &:nth-child(5n){
            margin-right: 0;
        }
        &:hover{
          box-shadow: 0 3px 20px rgba(0, 0, 0, 0.06);
        }
        .pictrue{
          width: 192px;
          height: 192px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .money{
          margin-top: 12px;
          .font-color{
            font-weight: bold;
            font-size: 22px;
          }
          .y_money{
            font-size: 12px;
            color: #AAAAAA;
            text-decoration: line-through;
            margin-left: 8px;
          }
          .label{
            width: 20px;
            height: 20px;
            background: linear-gradient(330deg, rgba(231, 85, 67, 0.15) 0%, rgba(244, 103, 83, 0.15) 100%);
            font-size: 12px;
            text-align: center;
            line-height: 20px;
          }
        }
        .name{
          color: #5A5A5A;
          margin-top: 8px;
          height: 40px;
        }
        .bottom{
          font-size: 12px;
          color: #AAAAAA;
          margin-top: 5px;
        }
        .item_tags{
          margin-top: 6px;
          display: flex;
          align-items: center;
          .font-bg-red{
            display: inline-block;
            background: #E93424;
            color: #fff;
            font-size: 10px;
            text-align: center;
            border-radius: 2px;
            padding: 0 2px;
            line-height: 16px;
            margin-right: 4px;
            border: 1px solid #E93424;
          }
          .tags_item{
            display: inline-block;
            font-size: 10px;
            text-align: center;
            border-radius: 2px;
            padding: 0 2px;
            line-height: 16px;
            margin-right: 4px;
            color: #E93323;
            border: 1px solid #E93323;
          
          }
        }
      }
    }
    .price-range{
        position: relative;
        top: -15px;
        padding: 10px;
        &:hover{
            box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.08);
            .action-box{
                display: block;
            }
        }
        .action-box{
            display: none;
            position: absolute;
            left: 0;
            bottom: -50px;
            text-align: center;
            background: #F9F9F9;
            height: 50px;
            line-height: 50px;
            width: 100%;
            box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.08);
            padding: 0 15px;
            overflow: hidden;
            .clear{
                float: left;
                color: #999999;
            }
            .submit{
                float: right;
                color: #666666;
                width: 60px;
                height: 30px;
                line-height: 30px;
                margin-top: 10px;
                background-color: #F1F1F1;
                border-radius: 2px;
                border: 1px solid #D4D4D4;
            }

        }
        .price-count{
            .input{
                width: 80px;
                height: 32px;
                position: relative;

                    &:before{
                        content: 'NZ$';
                        display: inline-block;
                        color: #D4D4D4;
                        position: absolute;
                        left: 5px;
                        top: 0;
                        line-height: 32px;
                    }
                ::v-deep .el-input__inner{
                    height: 32px;
                    line-height: 32px;
                    padding-left: 18px;
                }
            }
        }
    }
    .search-count{
        display: inline-block;
        background-color: #fff;
        height: 26px;
        line-height: 26px;
        color: #282828;
        padding: 0 10px;
        margin-bottom: 15px;
        .search-selected{
            display: inline-block;
            min-width: 100px;
            max-width: 200px;
            ::v-deep .el-input__inner{
                border: none;
                height: 26px;
                line-height: 26px;
                color: #969696;
            }
        }
        .el-icon-close{
            cursor: pointer;
            color: #969696;
            font-size: 12px;
        }
    }
  }
  .search-store{
      width: 1200px;
      margin: 0 auto 20px;
      border-radius: 4px;
      overflow: hidden;
      .moreBtn{
        width: 32px;
        height: 76px;
        padding: 10px 0;
        background-color: #fff;
        color: #999999;
        text-align: center;
        font-size: 12px;
        float: left;
            .iconfont{
                display: block;
                font-size: 8px;
                border: 1px solid #8B8B8B;
                border-radius: 100%;
                width: 11px;
                height: 11px;
                line-height: 11px;
                text-align: center;
                margin: 3px auto 0;
            }
        }
      .store-count{
          overflow: hidden;
          width: 100%;
          .item{
              height: 96px;
              width: 100%;
              -webkit-justify-content: space-between;
              justify-content: space-between;
              padding: 0 17px;
              background-color: #fff;
          }
          &.moreStore{
               float: left;
               width: auto;
              .item{
                width: 570px;
                float: left;
                margin-right: 14px;
              }
          }
          .store-name{
              align-items: center;
              .image{
                width: 61px;
                height: 61px;
                border-radius: 100%;
              img{
                width: 100%;
                height: 100%;
              }
            }
            .name{
                margin-left: 15px;
                color: #282828;
                line-height: 26px;
                >span{
                    display: block;
                    color: #999999;
                }
            }
          }
          .store-go{
              align-items: center;
              .store-btn{
                  width: 78px;
                  height: 30px;
                  line-height: 30px;
                  text-align: center;
                  border-radius: 4px;
                  font-size: 12px;
                  &.goIn{
                      color: #fff;
                      background-color: #E93323;
                      margin-right: 12px;
                      border: 1px solid #E93323;
                  }
                  &.collect{
                     color: #E93323;
                     border: 1px solid #E93323;
                     background-color: #fff;
                  }
                  &.hasCollect{
                      color: #999999;
                      border-color: #999999;
                  }
              }
          }

      }
  }
  .select-footer{
      text-align: center;
      margin: 30px 0;
  }
</style>
